import config from './config';
import guards from './guards';
import actions from './actions';
import * as services from './services';

const options = {
  actions,
  guards,
  services,
};

export { config, options };
